import { render, staticRenderFns } from "./highlight-banner.vue?vue&type=template&id=7ace9670&scoped=true&"
import script from "./highlight-banner.vue?vue&type=script&lang=js&"
export * from "./highlight-banner.vue?vue&type=script&lang=js&"
import style0 from "./highlight-banner.vue?vue&type=style&index=0&id=7ace9670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ace9670",
  null
  
)

export default component.exports